'use client';
import { useRef, useCallback, useEffect } from 'react';

var useTimeout = function(action, delay, options) {
    if (options === void 0) options = {
        autoInvoke: false
    };
    var autoInvoke = options.autoInvoke;
    var callbackRef = useRef(null);
    var timeoutRef = useRef(null);
    var start = useCallback(function() {
        for(var _len = arguments.length, callbackParams = new Array(_len), _key = 0; _key < _len; _key++){
            callbackParams[_key] = arguments[_key];
        }
        if (!timeoutRef.current) {
            timeoutRef.current = window.setTimeout(function() {
                callbackRef.current == null ? void 0 : callbackRef.current.call(callbackRef, callbackParams);
                timeoutRef.current = null;
            }, delay);
        }
    }, [
        delay
    ]);
    var clear = useCallback(function() {
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    useEffect(function() {
        callbackRef.current = action;
    }, [
        action
    ]);
    useEffect(function() {
        if (autoInvoke) {
            start();
        }
        return clear;
    }, [
        clear,
        delay,
        autoInvoke,
        start
    ]);
    return {
        start: start,
        clear: clear
    };
};

export { useTimeout };
